// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const ASSIGN_CASE_SUMMARY_CASE_DETAILS_TERR_CASE_ID = 'ASSIGN_CASE_SUMMARY_CASE_DETAILS_TERR_CASE_ID'
export const ASSIGN_CASE_SUMMARY_CHANNEL_CASE_LIST = 'ASSIGN_CASE_SUMMARY_CHANNEL_CASE_LIST'
export const ASSIGN_CASE_SUMMARY_OPEN_SUMMARY = 'ASSIGN_CASE_SUMMARY_OPEN_SUMMARY'
export const ASSIGN_CASE_SUMMARY_SELECTED_TERR_CASE_IDS = 'ASSIGN_CASE_SUMMARY_SELECTED_TERR_CASE_IDS'
export const CASE_SUMMARY_SHOW_ALL_CASES_TOGGLE = 'CASE_SUMMARY_SHOW_ALL_CASES_TOGGLE'
export const UPDATE_INTERFERENCE_ANALYSIS_STATE = 'UPDATE_INTERFERENCE_ANALYSIS_STATE'
export const ASSIGN_CASE_SUMMARY_CASE_OH_DETAILS_TERR_CASE_ID = 'ASSIGN_CASE_SUMMARY_CASE_OH_DETAILS_TERR_CASE_ID'
